var _rect, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMatlabLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    rx: 60,
    fill: "#F4F4ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 133.187L86.7974 111.452C92.2581 104.236 98.4069 97.5671 105.157 91.5398C109.612 89.1774 117.982 90.4598 133.305 71.4249C148.155 52.8625 152.88 37 159.832 37C170.835 37 178.935 60.7599 191.22 96.7373C199.979 124.218 210.254 151.192 221.999 177.535C209.175 165.587 198.24 152.695 185.752 153.032C174.142 153.302 161.25 167.072 147.142 184.757C135.937 198.932 121.087 208.652 115.282 208.45C115.282 208.45 100.297 166.06 87.7423 159.175C85.1376 158.111 82.318 157.678 79.514 157.913C76.7101 158.147 74.0016 159.042 71.6099 160.525L33 133.12V133.187Z",
    fill: "#4499DD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M153.151 41.8613C148.629 47.9363 143.161 59.0738 133.306 71.4262C117.984 90.4612 109.681 89.1787 105.159 91.5412C98.3761 97.5356 92.2242 104.208 86.7988 111.454L109.074 127.721C127.974 101.936 138.099 73.9912 145.996 55.9013C147.974 51.0246 150.368 46.3272 153.151 41.8613V41.8613Z",
    fill: "url(#paint0_linear_601_135)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M159.9 37C145.185 37 135.128 114.49 80.7905 157.757C96.0455 155.26 109.275 193.127 115.35 208.45C142.35 203.86 163.95 152.222 185.753 153.032C198.24 153.505 209.175 165.587 222 177.535C192.705 115.975 179.003 37 159.9 37Z",
    fill: "url(#paint1_linear_601_135)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_601_135",
    x1: 132.921,
    y1: 118.467,
    x2: 120.839,
    y2: 79.452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#551122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#552233"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#553344"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#664455"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#556688"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#2299DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_601_135",
    x1: 220.043,
    y1: 142.86,
    x2: 98.543,
    y2: 113.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.081,
    stopColor: "#CC3333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.189,
    stopColor: "#DE5239"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.313,
    stopColor: "#F06E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421,
    stopColor: "#FA8042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FE8643"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FA7F42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.696,
    stopColor: "#EF6C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.833,
    stopColor: "#DC4C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.916,
    stopColor: "#CF3633"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatlabLight);
export default __webpack_public_path__ + "static/media/Matlab-Light.9d4d9c8df3d3994d47942a855949d5fe.svg";
export { ForwardRef as ReactComponent };